// extracted by mini-css-extract-plugin
export default {"sketchPage":"SketchPage_sketchPage__geG74","excalidraWrapper":"SketchPage_excalidraWrapper__vwy+G","noData":"SketchPage_noData__+ChEw"};